export default "__VITE_ASSET__BjcSDYOG__"